import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IUnmanagedBusinessAutoRegisterSettingRepository } from '@/coreInfrastructureModule/interfaces/IUnmanagedBusinessAutoRegisterSettingRepository';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { UnmanagedBusinessAutoRegisterSettingAdapter } from '../adapters/unmanagedBusinessAutoRegisterSettingAdapter';
import { UnmanagedBusinessAutoRegisterSettingEntity } from '../domains/entities/unmanagedBusinessAutoRegisterSetting';

/**
 * 未管理取引の自動登録設定を保存するUseCase
 */
export class SaveUnmanagedBusinessAutoRegisterSettingUseCase {
  /**
   * コンストラクタ
   * @param repository - 未管理取引の自動登録設定を保存するRepository
   */
  constructor(private readonly repository: IUnmanagedBusinessAutoRegisterSettingRepository) {}

  /**
   * 設定を保存する
   * @param setting - 保存対象の設定
   */
  public Execute = async (
    setting: UnmanagedBusinessAutoRegisterSettingEntity
  ): Promise<INetworkResult<UnmanagedBusinessAutoRegisterSettingEntity, IError>> => {
    const result = await this.repository.put(UnmanagedBusinessAutoRegisterSettingAdapter.toPutRequest(setting));

    if (result.status.type === 'success') {
      return {
        status: {
          type: 'success',
          data: UnmanagedBusinessAutoRegisterSettingAdapter.toEntity(result.status.data),
        },
      };
    }

    return { status: result.status };
  };
}
